/**
 * @file events.constants.js
 * @module EventsConstants
 * @description Constants of the Events tool: statuses, table headers and
 * sort options. Field limits mirror the backend validation.
 */

export const EVENT_STATUS = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
});

export const EVENT_NAME_MAX_LENGTH = 150;
export const EVENT_CODE_MAX_LENGTH = 30;
export const EVENT_DESCRIPTION_MAX_LENGTH = 1000;

/** Letters, numbers, "_" and "-", as the backend accepts. */
export const EVENT_CODE_PATTERN = /^[A-Za-z0-9_-]+$/;

export const EVENT_STATUS_FILTERS = [
  {
    label: "Active",
    value: EVENT_STATUS.ACTIVE,
    icon: "flaticon-rec text-success"
  },
  {
    label: "Inactive",
    value: EVENT_STATUS.INACTIVE,
    icon: "flaticon-rec text-danger"
  }
];

export const EVENT_SORT_OPTIONS = [
  { value: "name", text: "Name" },
  { value: "code", text: "Code" },
  { value: "startDate", text: "Start Date" },
  { value: "endDate", text: "End Date" },
  { value: "status", text: "Status" },
  { value: "createdAt", text: "Created" }
];

export const EVENT_TABLE_HEADERS = [
  {
    key: "name",
    label: "Event",
    thStyle: { minWidth: "200px" },
    class: "text-left"
  },
  {
    key: "code",
    label: "Code",
    thStyle: { minWidth: "120px" },
    class: "alinmov6"
  },
  {
    key: "dates",
    label: "Dates",
    thStyle: { minWidth: "200px" },
    class: "alinmov6"
  },
  {
    key: "timezone",
    label: "Time Zone",
    thStyle: { minWidth: "150px" },
    class: "alinmov6"
  },
  {
    key: "customer",
    label: "Customer",
    thStyle: { minWidth: "150px" },
    class: "text-left"
  },
  {
    key: "status",
    label: "Status",
    thStyle: { minWidth: "100px" },
    class: "alinmov6"
  },
  {
    key: "actions",
    label: "Actions",
    thStyle: { minWidth: "100px" },
    class: "alinmov6"
  }
];
